import kingshottIodine from "@kingshott/iodine";

window.formValidation = () => {
    const fields = [
        { name: "email", errorMessage: "El email ingresado no es válido" },
        {
            name: "required",
            errorMessage: "Debe ingresar un valor para este campo",
        },
        {
            name: "integer",
            errorMessage: "Debe ingresar un número para este campo",
        },
        {
            name: "numeric",
            errorMessage: "Este campo sólo admite números",
        }
    ];
    return {
        inputElements: [],
        _version: 0,
        init() {
            //Set up custom Iodine rules
            Iodine.addRule(
                "matchingPassword",
                (value) => value === document.getElementById("password").value
            );
            Iodine.messages.matchingPassword =
                "Password confirmation needs to match password";
            //Set custom errors
            fields.forEach((field) => {
                Iodine.setErrorMessage(field.name, field.errorMessage);
            });
            Iodine.setErrorMessage(
                "required",
                `Debe ingresar un valor para este campo`
            );
            //Store an array of all the input elements with 'data-rules' attributes
            this.inputElements = [
                ...this.$el.querySelectorAll(
                    "input[data-rules], textarea[data-rules]"
                ),
            ];
            this.initDomData();
            this.updateErrorMessages();
        },
        initDomData: function () {
            //Create an object attached to the component state for each input element to store its state
            this.inputElements.map((ele) => {
                this[ele.name] = {
                    serverErrors: JSON.parse(ele.dataset.serverErrors),
                    blurred: false,
                };
            });
        },
        updateErrorMessages: function () {
            //map throught the input elements and set the 'errorMessage'
            this.inputElements.map((ele) => {
                this[ele.name].errorMessage = this.getErrorMessage(ele);
            });
            this._version++;
        },
        getErrorMessage: function (ele) {
            //Return any server errors if they're present
            if (this[ele.name].serverErrors.length > 0) {
                return input.serverErrors[0];
            }
            //Check using iodine and return the error message only if the element has not been blurred
            const error = Iodine.is(ele.value, JSON.parse(ele.dataset.rules.replace(/'/g, '"')));
            if (error !== true && this[ele.name].blurred) {
                ele.setCustomValidity('required')
                return Iodine.getErrorMessage(error);
            }
            //return empty string if there are no errors
            ele.setCustomValidity('')
            return "";
        },
        submit: function (event) {
            const invalidElements = this.inputElements.filter((input) => {
                return (
                    Iodine.is(input.value, JSON.parse(input.dataset.rules.replace(/'/g, '"'))) !==
                    true
                );
            });
            const hasInvalidElements = invalidElements.length > 0
            if (hasInvalidElements) {
                event.preventDefault();
                let element = document.getElementById(invalidElements[0].id);
                element.setCustomValidity('required')
                if (element.hasAttribute("scroll-to"))
                    element = document.getElementById(
                        element.getAttribute("scroll-to")
                    );
                element.scrollIntoView({
                    alignToTop: true,
                    behavior: "smooth",
                    block: "center",
                });
                //We set all the inputs as blurred if the form has been submitted
                this.inputElements.map((input) => {
                    this[input.name].blurred = true;
                });
                //And update the error messages.
                this.updateErrorMessages();
                window.dispatchEvent(new CustomEvent('submittedform'));
            }
            return hasInvalidElements
        },
        change: function (event) {
            //Ignore all events that aren't coming from the inputs we're watching
            const tracked = this.inputElements.find(el => el.name === event.target.name);
            if (!tracked) {
                return false;
            }
            if (event.type === "input") {
                this[event.target.name].serverErrors = [];
            }
            if (event.type === "focusout") {
                this[event.target.name].blurred = true;
            }
            //Whether blurred or on input, we update the error messages
            this.updateErrorMessages();
        },
        isValidForm: function () {
            void this._version;
            const invalidElements = this.inputElements.filter((input) => {
                return (
                    Iodine.is(input.value, JSON.parse(input.dataset.rules.replace(/'/g, '"'))) !==
                    true
                );
            });
            return invalidElements.length == 0;
        }
    };
};
